export const PanelDebugName = 'SelectablePanel';